export enum InvoiceType {
  MONTH = 'MONTH',

  YEAR = 'YEAR',

  END = 'END',
}
